import Button from 'react-bootstrap/Button';
import HistoryIcon from './components/HistoryIcon';
import Modal from 'react-bootstrap/Modal';
import { ApiReturn } from '@/modules/api.service';
import { GetHistoricoTabela, TratarDiferenca } from '@/modules/system/historico/historico.service';
import { HistoricoDto } from '@/api.types';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';

interface IMyProps {
  tabela: string;
  idRegistro: number | string;
  show: boolean;
  handleHide: () => void;
}

function nomeAcao(acao: string) {
  switch (acao) {
    case 'INSERT':
      return 'CRIAR';
    case 'UPDATE':
      return 'ATUALIZAR';
    default:
      return acao;
  }
}

function HistoryRow({ item, diffMap }: { item: any; diffMap: Record<string, any>; }) {
  const diffEntries = Object.entries(diffMap);

  return (
    <tr>
      <th scope="row">{format(new Date(item.criadoEm), 'dd/MM/yyyy HH:mm')}</th>
      <td className="text-center">{nomeAcao(item.acao)}</td>
      <td>{item.criadoPor?.username}</td>
      <td>
        <div className="d-flex gap-2">
          {diffEntries.map(([key, value]) => (
            <HistoryIcon key={key} fieldNumber={Number(key)} value={value} />
          ))}
        </div>
      </td>
    </tr>
  );
}

export default function ModalHistorico({ show, tabela, idRegistro, handleHide }: IMyProps) {

  const [registros, setRegistros] = useState<ApiReturn<HistoricoDto>>({ objects: [], count: 0, });

  // ID numérico: válido quando > 0. ID texto (ex.: UUID em pessoas): válido quando não vazio e não "0"
  const idValido =
    idRegistro != null &&
    (typeof idRegistro === 'string'
      ? idRegistro.trim() !== '' && idRegistro.trim() !== '0'
      : Number(idRegistro) > 0);

  // Buscar histórico apenas quando o modal for aberto e o registro já existir (id > 0)
  useEffect(() => {
    if (!show) return;
    if (!idValido) {
      setRegistros({ objects: [], count: 0 });
      return;
    }
    GetHistoricoTabela(tabela, idRegistro)
      .then(setRegistros)
      .catch(console.error);
  }, [show, tabela, idRegistro, idValido]);

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Histórico do Registro ({tabela})
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!idValido ? (
          <p className="text-muted mb-0">Registro ainda não foi salvo. Não há histórico.</p>
        ) : (
          <table className="table table-sm table-striped table-hover">
            <thead>
              <tr>
                <th>Data</th>
                <th className="text-center">Ação</th>
                <th>Usuário</th>
                <th>Detalhes</th>
              </tr>
            </thead>
            <tbody className="table-group-divider">
              {registros.objects.map((item, index) => {
                const diffMap = TratarDiferenca(item.diff);
                return <HistoryRow key={index} item={item} diffMap={diffMap} />;
              })}
            </tbody>
          </table>
        )}
      </Modal.Body>
      <Modal.Footer className="text-left">
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}